export default __webpack_public_path__ + "static/media/fishlike_spaceship_preview.cc2ff016.png";